// src/components/shared/Logo.js
// Logo Fynho - l'image est servie directement depuis /logo.webp sur le serveur - NE PAS MODIFIER LA STRUCTURE

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const Logo = ({ size = 'medium', showText = true }) => {
  const { theme } = useTheme();

  const sizes = {
    small: { box: '32px', font: '18px', text: '18px' },
    medium: { box: '40px', font: '22px', text: '22px' },
    large: { box: '56px', font: '30px', text: '30px' },
  };
  const s = sizes[size] || sizes.medium;

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    imageBox: {
      width: s.box,
      height: s.box,
      borderRadius: '10px',
      objectFit: 'cover',
      display: 'block',
    },
    text: {
      fontSize: s.text,
      fontWeight: '700',
      color: theme.gold,
      lineHeight: '1',
      letterSpacing: '-0.5px',
    },
  };

  return (
    <div style={styles.container}>
      <img src="/logo.webp" alt="Fynho" style={styles.imageBox} />
      {showText && <span style={styles.text}>Fynho</span>}
    </div>
  );
};

export default Logo;